/**
 * Microservice base URLs.
 * - Dev: localhost ports (unchanged).
 * - Prod: https://<docker-compose-service-name>.<domain> (default domain compcheck.io).
 * Override any URL with the matching REACT_APP_*_SERVICE_URL env var.
 */

const INTERNAL_DOMAIN = (process.env.REACT_APP_INTERNAL_SERVICE_DOMAIN || "compcheck.io")
  .replace(/^\.+/, "")
  .replace(/\/+$/, "");

export function isProductionServiceHosts(): boolean {
  const e = (process.env.REACT_APP_ENV || "").toLowerCase().trim();
  return e === "production" || e === "prod";
}

function prodServiceBase(dockerServiceName: string): string {
  return `https://${dockerServiceName}.${INTERNAL_DOMAIN}`;
}

function pick(envKey: string, dockerName: string, devUrl: string): string {
  const fromEnv = process.env[envKey];
  if (fromEnv && String(fromEnv).trim() !== "") return String(fromEnv).replace(/\/+$/, "");
  return isProductionServiceHosts() ? prodServiceBase(dockerName) : devUrl;
}

export function resolveAuthServiceUrl(): string {
  return pick("REACT_APP_AUTH_SERVICE_URL", "auth-service", "http://localhost:3001");
}

export function resolveUserServiceUrl(): string {
  return pick("REACT_APP_USER_SERVICE_URL", "user-service", "http://localhost:3002");
}

export function resolveCourseServiceUrl(): string {
  return pick("REACT_APP_COURSE_SERVICE_URL", "course-service", "http://localhost:5078");
}

export function resolveNotificationServiceUrl(): string {
  return pick("REACT_APP_NOTIFICATION_SERVICE_URL", "notification-service", "http://localhost:3004");
}

export function resolveAssessmentServiceUrl(): string {
  return pick("REACT_APP_ASSESSMENT_SERVICE_URL", "course-service", "http://localhost:5078");
}

export function resolvePaymentServiceUrl(): string {
  return pick("REACT_APP_PAYMENT_SERVICE_URL", "payment-service", "http://localhost:3007");
}

export function resolveSubdomainServiceUrl(): string {
  return pick("REACT_APP_SUBDOMAIN_URL", "subdomain-service", "http://localhost:7005");
}

export function resolveBaseUrl(): string {
  const fromEnv = process.env.REACT_APP_BASE_URL;
  if (fromEnv && String(fromEnv).trim() !== "") return String(fromEnv).replace(/\/+$/, "");
  return resolveAuthServiceUrl();
}

/** CompCheck main app (sidebar external link). */
export function resolveCompCheckAppUrl(): string {
  const fromEnv = process.env.REACT_APP_COMPCHECK_APP_URL;
  if (fromEnv && String(fromEnv).trim() !== "") return String(fromEnv).replace(/\/+$/, "");
  return isProductionServiceHosts()
    ? "https://app.compcheck.io"
    : "http://localhost:3000";
}
